// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__21Ujd","list":"styles_list__3dh9d"};